__webpack_require__.p = "/perfect-sequence/";